import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ResetComponent } from './auth/reset/reset.component';
import { AutomationComponent } from './pages/automation/automation.component';
import { CompanyComponent } from './pages/company/company.component';
import { CourtsComponent } from './pages/courts/courts.component';
import { DiaryComponent } from './pages/diary/diary.component';
import { BarristerDiaryComponent } from './pages/barrister-diary/barrister-diary.component';
import { HomeComponent } from './pages/home/home.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { AuthGuard } from './service/auth/auth.guard';

const routes: Routes = [
  { path : 'auth/login', component : LoginComponent},
  { path : 'auth/reset', component : ResetComponent},
  { path : 'pages/cases', loadChildren: () => import('./pages/cases/cases.module').then(m => m.CasesModule), canActivate : [AuthGuard] },
  { path : 'pages/solicitors', loadChildren: () => import('./pages/solicitors/solicitors.module').then(m => m.SolicitorsModule), canActivate : [AuthGuard] },
  { path : 'pages/barristers', loadChildren: () => import('./pages/barristers/barristers.module').then(m => m.BarristersModule), canActivate : [AuthGuard] },
  { path : 'pages/clients', loadChildren: () => import('./pages/clients/clients.module').then(m => m.ClientsModule), canActivate : [AuthGuard] },
  { path : 'pages/tasks', loadChildren: () => import('./pages/tasks/tasks.module').then(m => m.TasksModule), canActivate : [AuthGuard] },
  { path : 'pages/meetings', loadChildren: () => import('./pages/meetings/meetings.module').then(m => m.MeetingsModule), canActivate : [AuthGuard] },
  { path : 'pages/users', loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule), canActivate : [AuthGuard]},
  { path : 'pages/financial', loadChildren: () => import('./pages/financial/financial.module').then(m => m.FinancialModule), canActivate : [AuthGuard]},
  { path : 'pages/report', loadChildren: () => import('./pages/report/report.module').then(m => m.ReportModule), canActivate : [AuthGuard]},
  { path : 'pages/archieved', loadChildren: () => import('./pages/archieved/archieved.module').then(m => m.ArchievedModule), canActivate : [AuthGuard]},
  { path : 'pages/home', component : HomeComponent, canActivate : [AuthGuard]},
  { path : 'pages/courts', component : CourtsComponent, canActivate : [AuthGuard]},
  { path : 'pages/diary', component : DiaryComponent, canActivate : [AuthGuard]},
  { path : 'pages/barrister-diary', component : BarristerDiaryComponent, canActivate : [AuthGuard]},
  { path : 'pages/company', component : CompanyComponent, canActivate : [AuthGuard]},
  { path : 'pages/settings', component : SettingsComponent, canActivate : [AuthGuard]},
  { path : 'pages/automation', component : AutomationComponent, canActivate : [AuthGuard]},
  { path : '', redirectTo : 'auth/login', pathMatch : 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes , { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
